import { Component } from '@angular/core';
import { ThemeSwitcherService } from './@data/services/theme-switcher.service';

@Component({
  selector: 'ops-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ops';

  constructor(private themeSwitcher: ThemeSwitcherService){
    this.themeSwitcher.changeTheme('CoreTheme');
  }
}
